import clsx from 'clsx';
import styles from './StepperFormModal.module.scss';

interface StepTabsProps<TStepId extends string> {
  steps: readonly { id: TStepId; label: string }[];
  activeStepId: TStepId;
  /** Last index the current nav mode allows; later tabs render locked. */
  maxReachableIndex: number;
  onSelect: (stepId: TStepId) => void;
}

const StepTabs = <TStepId extends string>({ steps, activeStepId, maxReachableIndex, onSelect }: StepTabsProps<TStepId>) => (
  <div className={styles.stepTabs} role="tablist">
    {steps.map((step, index) => {
      const isActive = step.id === activeStepId;
      const isLocked = index > maxReachableIndex;
      return (
        <button
          key={step.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          disabled={isLocked}
          className={clsx(styles.stepTab, isActive && styles.stepTabActive, isLocked && styles.stepTabLocked)}
          onClick={() => onSelect(step.id)}
        >
          {step.label}
        </button>
      );
    })}
  </div>
);

export default StepTabs;
